import { render, staticRenderFns } from "./phone-frame.vue?vue&type=template&id=ccb36616&scoped=true"
import script from "./phone-frame.vue?vue&type=script&lang=js"
export * from "./phone-frame.vue?vue&type=script&lang=js"
import style0 from "./phone-frame.vue?vue&type=style&index=0&id=ccb36616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb36616",
  null
  
)

export default component.exports